
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-general-english-workshop",
      function () {
        return require("private-next-pages/tnpsc-general-english-workshop/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-general-english-workshop"])
      });
    }
  